import { callWaiter } from 'redux-waiter'
import { createErrorNotification } from 'modules/app-core/notification-manager/actions'

import { GET_ALL_COMPANIES } from './constants'
import t from './actionTypes.js'

import { fetchAdministeredCompanies } from 'modules/client-service/methods'

export const resetCompanyList = () => ({
  type: t.RESET_COMPANY_LIST,
})

export const receiveCompanyList = (companyList) => ({
  type: t.RECEIVE_COMPANY_LIST,
  payload: companyList,
})

export const receiveCompany = (company) => ({
  type: t.RECEIVE_COMPANY,
  payload: company,
})

export const getAllCompanies = () => (dispatch) =>
  dispatch(
    callWaiter(GET_ALL_COMPANIES, {
      requestCreator: async () => {
        try {
          const result = await fetchAdministeredCompanies()
          const companies = (result || []).map((company) => ({
            ...company,
            companyName: company.companyName || company.name,
          }))
          dispatch(receiveCompanyList(companies))
          return companies
        } catch (error) {
          dispatch(
            createErrorNotification(
              'We had trouble loading persons. Please reload the page'
            )
          )
          throw error
        }
      },
    })
  )
